/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
import { t } from 'i18next';
import React, { useRef } from 'react';
import { useState } from 'react';
import useOutsideClick from 'shared/hooks/useOutsideClick';
import { ControlsIcon, DotsHorizontalIcon, PenIcon, SortIcon } from 'shared/components/Icons';

const MobileSettingMenu = ({
  onFilterClick,
  disableFilterButton,
  onSortClick,
  disableSortButton,
  project,
  onEditProjectClick,
}) => {
  const [open, setOpen] = useState(false);
  const dropdown = useRef();

  const toggleDropdown = () => setOpen(!open);
  useOutsideClick([dropdown], () => setOpen(false));

  return (
    <div className={`mobile-drop-menu d-flex align-items-center ${open ? 'active' : ''}`}>
      <div className='btn p-0 action-btn action-btn-toggle' onClick={toggleDropdown} role='presentation'>
        <DotsHorizontalIcon />
      </div>
      <div className='drop-content' ref={dropdown}>
        <div className='d-flex align-items-center justify-content-around pt-7 pb-5'>
          <div
            className='border-right d-flex align-items-center justify-content-center text-body col'
            onClick={() => {
              setOpen(false);
              onFilterClick();
            }}
            disabled={disableFilterButton}
          >
            <ControlsIcon className='mr-5' />
            {t('btn_filter')}
          </div>
          {!!project && (
            <div
              className='border-right text-nowrap d-flex align-items-center justify-content-center text-body col'
              onClick={() => {
                setOpen(false);
                onEditProjectClick();
              }}
              disabled={disableFilterButton}
            >
              <PenIcon className='mr-5' />
              {t('btn_edit_project')}
            </div>
          )}
          <div
            className='d-flex align-items-center justify-content-center text-body col'
            onClick={() => {
              setOpen(false);
              onSortClick();
            }}
            disabled={disableSortButton}
          >
            <SortIcon className='mr-5' />
            {t('btn_sorting')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileSettingMenu;
